import {getElement, removeActive} from './helpers.js'
import {header} from "./elements.js";


export default function menu() {
    const navItems = header.querySelectorAll('.navigation__item');

    navItems.forEach(item => {
        if (!item.querySelector('.submenu__wrapper')) return;
        const submenu = item.querySelector('.submenu__wrapper');


        item.addEventListener('click', (e) => {
            if (item.classList.contains('active')) return;
            if (screen.width >= 1024) {
                let itemPseudoAfter = window.getComputedStyle(item.parentElement, "::after");
                if (parseInt(itemPseudoAfter.minHeight) <= submenu.clientHeight) {
                    item.parentElement.style.setProperty('--min-Height', `${submenu.clientHeight + 'px'}`);
                } else {
                    item.parentElement.style.setProperty('--min-Height', `36.1rem`);
                }
            }
            removeActive(navItems);
            removeHide(header.querySelectorAll('.submenu__wrapper'));
            if (!item.parentElement.classList.contains('active')) item.parentElement.classList.add('active');
            item.classList.add('active');
            submenu.classList.remove('hide');
            submenu.classList.add('show');


            // document.body.classList.add('active');
            document.body.classList.add('no-touch');
            header.classList.add('active')


        });
        document.body.addEventListener('click', (event) => {

            if (item.querySelector('.submenu__wrapper').classList.contains('show')) {

                if (event.target == getElement('.navigation__menu') || !event.target.closest(".header") || event.target.classList.contains('btn-close') || event.target.classList.contains('burger')) {
                    removeActive(navItems);
                    submenu.classList.remove('show');
                    submenu.classList.add('hide');
                    header.classList.remove('active')
                    setTimeout(() => {
                        item.parentElement.classList.remove('active');
                        // document.body.classList.remove('active');
                        document.body.classList.remove('no-touch');
                    }, 100);
                }
            }
        })
        submenu.querySelector('.submenu__header ').addEventListener('click', (e) => {
            e.stopPropagation();
            item.classList.remove('active');
            submenu.classList.remove('show');
            submenu.classList.add('hide');
        })

    })


}

function removeHide(arr) {
    arr.forEach((item) => {
        item.classList.remove("show");
        item.classList.add('hide')
    });
}